import { Injectable } from '@angular/core';
import { User } from '../../state/auth/types';

/**
 * Copies a row's target stock onto the ERP's own order-row stock field. Used by the AI order
 * parser; each ERP subclass mirrors the stamping in that ERP's AssignOrderRows checkout step.
 * Pass-through here; each ERP library provides its own subclass.
 */
@Injectable({
  providedIn: 'root'
})
export class CheckoutRowStockService {
  public assignStock<T extends { targetStockId?: string; extra?: any }>(rows: T[], user?: User): T[] {
    return rows;
  }
}
